import { ReactElement } from 'react';

import { DoctorSimple } from '@dreryk/egabinet-personnel-frontend-api';

import { useHealthcareProviderDoctorsQuery } from '~legacy.personnel';

type PatientPrescriptionsHistoryRenderProps = {
   readonly doctors: DoctorSimple[];
};

type PatientPrescriptionsHistoryLoaderProps = {
   readonly children: (renderProps: PatientPrescriptionsHistoryRenderProps) => ReactElement;
};

export const PatientPrescriptionsHistoryLoader = (
   props: PatientPrescriptionsHistoryLoaderProps
): ReactElement | null => {
   const { data: doctors, loading: doctorsLoading } = useHealthcareProviderDoctorsQuery();

   if (doctorsLoading || !doctors) {
      return null;
   }

   return props.children({ doctors: doctors });
};
